import React from "react";

function AdminProductoRow({
  prod,
  handleSeleccionarEditar,
  handleCambiarDisponibilidad,
  handleEliminarProducto,
}) {
  const activo =
    prod.disponible &&
    !(prod.bloqueadoHasta && new Date(prod.bloqueadoHasta) > new Date());

  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        alignItems: "center",
        backgroundColor: activo ? "#fff" : "#fce8e6",
        padding: "14px",
        borderRadius: "12px",
        border: "1px solid #e2e2e2",
      }}
    >
      <img
        src={prod.imagen}
        alt=""
        loading="lazy"
        decoding="async"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "8px",
          objectFit: "cover",
        }}
      />

      <div style={{ flex: 1 }}>
        <span
          style={{
            fontSize: "15px",
            fontWeight: "700",
            display: "block",
          }}
        >
          {prod.nombre} — ${prod.precio}
        </span>

        <span
          style={{
            fontSize: "11px",
            backgroundColor: "#e8f0fe",
            padding: "2px 6px",
            borderRadius: "4px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          📁 {prod.seccion || "CARTA"}
        </span>
      </div>

      <div
        style={{
          display: "flex",
          gap: "6px",
          flexWrap: "wrap",
          justifyContent: "flex-end",
        }}
      >
        <button
          type="button"
          onClick={() => handleSeleccionarEditar(prod)}
          style={{
            padding: "6px 12px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          Editar
        </button>

        {activo ? (
          <button
            type="button"
            onClick={() => handleCambiarDisponibilidad(prod, "24h")}
            style={{
              padding: "6px 10px",
              border: "1px solid #f0b000",
              borderRadius: "6px",
              backgroundColor: "#feefc3",
              color: "#b06000",
              fontSize: "12px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            🚫 Pausar
          </button>
        ) : (
          <button
            type="button"
            onClick={() => handleCambiarDisponibilidad(prod, "activar")}
            style={{
              padding: "6px 12px",
              border: "1px solid #c2e7cd",
              borderRadius: "6px",
              backgroundColor: "#e6f4ea",
              color: "#137333",
              fontSize: "12px",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            ✅ Activar
          </button>
        )}

        <button
          type="button"
          onClick={() => handleEliminarProducto(prod)}
          style={{
            padding: "6px 10px",
            border: "1px solid #ffcdd2",
            borderRadius: "6px",
            backgroundColor: "#fff4f4",
            color: "#b00020",
            fontSize: "12px",
            fontWeight: "800",
            cursor: "pointer",
          }}
        >
          🗑️ Eliminar
        </button>
      </div>
    </div>
  );
}

export default AdminProductoRow;
